import React, { useRef, useMemo } from 'react';
  import { COLUMNS } from '../jsx/components/table/FilteringTable/ColumnOrders';
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
 import '../jsx/components/table/FilteringTable/filtering.css';
  import { SVGICON } from '../../src/jsx/constant/theme';
 import loadable from "@loadable/component";
 // import { Link } from 'react-router-dom';
 import { Row, Col, Card } from "react-bootstrap";
 import { useEffect, useState } from 'react';
 import UpcomingBlog from '../../src/jsx/components/Dashboard/elements/UpcomingBlog';
  import pMinDelay from "p-min-delay";
 
export const CompanyExpenses = () => {
const [AllEmployees, setAllEmployees] = useState(0)
const [Allunderprocess, setAllunderprocess] = useState(0)
const [Allreadyprocess, setAllreadyprocess] = useState(0)
const [del, setDel] = useState(0)
const [can, setCan] = useState(0)
useEffect(() => {
    countAllEmployees();
    getcount()

}, [])
const countAllEmployees = () => {
    axios.get('https://subk.education.com.ly/back/api/countAllEmployees')
     .then(({ data }) => {
        setAllEmployees(data)
     })}
     const getcount = () => {
        axios.get('https://subk.education.com.ly/back/api/getcount')
         .then(({ data }) => {
            setAllunderprocess(data.underCount)
            setAllreadyprocess(data.readyCount)
            setDel(data.delCount)
            setCan(data.canceledCount)
              })}
         console.log(del,Allunderprocess,Allreadyprocess,can)
     const cardBlog = [
        {svg:<i class="fa-solid fa-people-carry-box" style={{color: 'green'}}></i>, number: del, title:'تم تسليمها', changetheme:'success'},
        {svg:SVGICON.CardProgress, number:Allunderprocess, title:' قيد العمل', changetheme:'primary'},
        {svg: <i class="fa-solid fa-box" style={{color: 'purple'}} ></i>, number:Allreadyprocess, title:'جاهزة لتسليم', changetheme:'purple'},
        {svg:<i class="fa-solid fa-clock-rotate-left" style={{color: 'red'}} ></i>, number:can, title:'قيد الانتظار', changetheme:'danger'},
    ];
    
    const [company, setcompany] = useState([]);
     useEffect(() => {
      const companydata = localStorage.getItem('companies');
      if (companydata) {
        const parsedData = JSON.parse(companydata);
        const singleCompany = Array.isArray(parsedData) ? parsedData[0] : parsedData;
        setcompany(singleCompany); // Set state to a single object
      }
    }, []);
const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');
const userPermissions = JSON.parse(userPermissionsJSON);
function getActionsForPage(pageName) {
  const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
  console.log('actionsForPage', pagePermissions);
  if (pagePermissions) {
    return pagePermissions.action;
  } else {
    navigate('/dashboard_1')

    return [];
  }
}
const pageName = 'OrdersList';
   const navigate = useNavigate();
  const svg1 = (
  <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="24" height="24"></rect>
      <circle fill="#000000" cx="5" cy="12" r="2"></circle>
      <circle fill="#000000" cx="12" cy="12" r="2"></circle>
      <circle fill="#000000" cx="19" cy="12" r="2"></circle>
    </g>
  </svg>
)
const [report, setreport] = useState({})
const userdata1 = localStorage.getItem('USER_data');
const userData = JSON.parse(userdata1);
const userid = userData.id;

  return (
    <>
      <div className='container-fluid'>
      {/* <div className="row">
                    {cardBlog.map((item, ind)=>(
                        <div className="col-xl-3 col-sm-6" key={ind}>
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className={`icon-box icon-box-lg rounded-circle bg-${item.changetheme}-light`} >
                                            {item.svg}               
                                        </div>
                                        <div className="total-projects ms-3">
                                            <h3 className={`count text-${item.changetheme}`}>{item.number}</h3> 
                                            <span>{item.title}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                 
                  
                </div> */}
           <div className="row">
          <div className="col-xl-8  ">
                    <div className="card upgrade">
                         
                        <div className="card-body">
                            <div className="text-center">
                                <img src={`https://subk.education.com.ly/back${company.DashboardPhoto}`} alt="" />
                            </div>
                         </div>
                    </div>
                </div> 

            <div className="col-xl-3 respo col-xxl-4 col-lg-5">
              <div className="row">
                <div className="col-xl-12">
                  <UpcomingBlog />
                </div>

              </div>
            </div>
          </div>
        </div>
 


    </>
         
    





  );
}
export default CompanyExpenses;

